import { TextField } from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import {
  buildMenuItems,
  handleChangeMultiple,
  getSelectedChildren,
  renderChips,
  convertNullOrUnreadyToEmptyArray,
} from "./helpers";
import { SelectMultipleCheckboxDialog } from "./SelectMultipleCheckboxDialog";
import { SelectProps, ItemType, ItemIdType } from "../types";

let uniqueId = 0;

export const SelectMultipleCheckbox: React.FC<SelectProps> = ({
  lookupTracker,
  ...props
}) => {
  const {
    name,
    id,
    value,
    children,
    disabled,
    onChange,
    datatest,
    label,
  } = props;

  const [dialogOpen, setDialogOpen] = useState(false);

  // to stop errors if the value is known but the items have not loaded yet
  //  (Material UI moans about value "foo" being applied to a select with no
  //  item that has value="foo", but is happy to get given "" until items load)
  const safeValue = convertNullOrUnreadyToEmptyArray(value, !!children.length);
  const knownId = useMemo(() => id || `selectMultiplecheckbox_${++uniqueId}`, [
    id,
  ]);
  const menuItems = buildMenuItems(knownId, children, safeValue);
  const selectedChildren = getSelectedChildren(safeValue, children);

  const onDelete = (item: ItemType) =>
    handleChangeMultiple(name, item, safeValue, true, onChange);

  useEffect(() => {
    if (name && lookupTracker) {
      selectedChildren.forEach((selectedChild) =>
        lookupTracker.register({
          name,
          id: selectedChild.id,
          label: selectedChild.label,
        })
      );
    }
  }, [children, selectedChildren]);

  return (
    <>
      <TextField
        select
        id={knownId}
        variant="outlined"
        fullWidth
        {...props}
        value={safeValue}
        onClick={() => !disabled && setDialogOpen(true)}
        onKeyPress={() => !disabled && setDialogOpen(true)}
        SelectProps={{
          open: false,
          multiple: true,
          renderValue: () =>
            renderChips(selectedChildren, knownId, disabled, onDelete),
        }}
        data-test={datatest}
      >
        {menuItems}
      </TextField>
      <SelectMultipleCheckboxDialog
        dialogOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        children={children}
        selectedItems={safeValue}
        onChange={onChange}
        name={name}
        datatest={datatest}
        dialogTitle={"Select " + label}
      />
    </>
  );
};
